import { render, staticRenderFns } from "./create-call-log.vue?vue&type=template&id=36b758b4&"
import script from "./create-call-log.vue?vue&type=script&lang=js&"
export * from "./create-call-log.vue?vue&type=script&lang=js&"
import style0 from "./create-call-log.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports